import { useDocumentData } from "react-firebase-hooks/firestore";
import { doc, collection, setDoc, getDocs, deleteDoc } from "firebase/firestore";
import { useFirebaseRef as useCalculatorFirebaseRef } from "../useCalculatorActivity/useCalculatorActivity";
import { useAuthUserDataContext } from "hooks/useAuthUserData/useAuthUserData";

export const useFirebaseRef = (userId) => {
  const { authUserData } = useAuthUserDataContext();
  const activityRef = useCalculatorFirebaseRef();
  
  if (!activityRef || !authUserData) return null;
  
  const id = userId || authUserData?.id;
  if (!id) return null;
  
  return doc(collection(activityRef, "users"), id);
};

export const useUserCalculator = (userId) => {
  const ref = useFirebaseRef(userId);
  const [calculator, loading, error] = useDocumentData(ref, { idField: "id" });

  const update = (data) => {
    if (!ref) return Promise.reject(new Error("No reference available"));
    return setDoc(ref, data, { merge: true });
  };

  const set = (data) => {
    if (!ref) return Promise.reject(new Error("No reference available"));
    return setDoc(ref, data);
  };

  return { calculator, loading, error, update, set };
};

export const useUserCalculatorUpdate = () => {
  const activityRef = useCalculatorFirebaseRef();

  const update = async (userId, data, clearHistory) => {
    if (!activityRef || !userId) return;
    
    const userRef = doc(collection(activityRef, "users"), userId);
    
    if (clearHistory) {
      const historyCollection = collection(userRef, "history");
      const querySnapshot = await getDocs(historyCollection);
      
      // Delete each document in the history collection
      const deletePromises = querySnapshot.docs.map(snapshot => 
        deleteDoc(doc(historyCollection, snapshot.id))
      );
      
      await Promise.all(deletePromises);
    }

    return setDoc(userRef, data, { merge: true });
  };

  return { update };
};
